import Form from 'utils/form';

export const enableForm = (selector) => new Form(document.querySelector(selector)).enable();

export const resetForm = (selector) => new Form(document.querySelector(selector)).reset();
